export default __webpack_public_path__ + "static/media/doc-list-tick.e2ed50d7.svg";